export function resolveDeviceMethods(methods, environment) {
    return typeof methods === 'function' ? methods(environment) : methods;
}
